import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  SearchForTaskContexts as SearchForTaskContextsGenerated,
  SearchForTaskContexts_searchWithMetadata_items as SearchForTaskContextsItemGenerated,
  SearchForTaskContexts_searchWithMetadata_items_resource_TaskContext_contextFeatures as SearchForTaskContextsResourceFeaturesGenerated,
  SearchForTaskContexts_searchWithMetadata_items_resource_TaskContext as SearchForTaskContextsResourceGenerated,
  SearchForTaskContextsVariables as SearchForTaskContextsVariablesGenerated,
} from "core/queries/__generated__/SearchForTaskContexts";

export interface SearchForTaskContextsVariables
  extends SearchForTaskContextsVariablesGenerated {}
export interface SearchForTaskContextsResponse
  extends SearchForTaskContextsGenerated {}
export interface SearchForTaskContextsItem
  extends SearchForTaskContextsItemGenerated {}
export interface SearchForTaskContextsResource
  extends SearchForTaskContextsResourceGenerated {}
export interface SearchForTaskContextsResourceFeatures
  extends SearchForTaskContextsResourceFeaturesGenerated {}

export const searchForTaskContexts = gql`
  query SearchForTaskContexts(
    $searchTerm: String!
    $filters: SearchFilterInput
    $pagination: Pagination
    $sorting: Sorting
  ) {
    searchWithMetadata(
      searchTerm: $searchTerm
      resultType: task_context
      filters: $filters
      pagination: $pagination
      sorting: $sorting
    ) {
      total
      cursor
      hasMore
      items {
        id
        title
        subtitle
        description
        resource {
          ... on TaskContext {
            id
            name
            contextFeatures: features {
              defaultValue
              mutable
              name
              required
            }
            contextDetails {
              id
              order
              contextItem {
                id
                displayName
                name
                nameLocalized
              }
            }
            taskCategory {
              id
              name
            }
            taskLocation {
              id
              name
              place
            }
          }
        }
      }
    }
  }
`;

export interface UseSearchForTaskContexts {
  skip?: boolean;
  variables: SearchForTaskContextsVariables;
}

export const useSearchForTaskContexts = ({
  skip = false,
  variables,
}: UseSearchForTaskContexts) =>
  useQuery<SearchForTaskContextsResponse, SearchForTaskContextsVariables>(
    searchForTaskContexts,
    {
      skip,
      variables,
      notifyOnNetworkStatusChange: true,
    },
  );
